@if (useStandard) {
  <crm-standard-single-select
    [descriptorApiUrl]="descriptorUrl"
    [selectedValue]="selectedFilial"
    (selectedValueChange)="onSelected($event)"
    [class]="class"
    [styleClass]="styleClass"
    [showClear]="showClear"
    [disabled]="disabled"
    [isError]="isError"
    [appendTo]="appendTo"></crm-standard-single-select>
} @else {
  <crm-single-select
    [options]="filials"
    [selectedItem]="selectedFilial"
    (selectedItemChange)="onSelected($event)"
    [showClear]="showClear"
    [styleClass]="styleClass"
    [class]="class"
    [appendTo]="appendTo"
    [disabled]="disabled"
    [isError]="isError"
    [loading]="loading"></crm-single-select>
}
